import { getBrandMode, hexToRgb } from "../../config/brand-colors";
import { DARK_SURFACE, LIGHT_SURFACE } from "../../theme/surfaceTokens";

const BRAND_CSS_VARS = [
  "--brand",
  "--accent",
  "--ring",
  "--pending",
  "--chart-1",
  "--background-active",
  "--sidebar-ring",
  "--dx-color-primary",
];

/**
 * Injects brand CSS variables on :root so scoped CSS, MUI-adjacent styles and DevExtreme
 * stay in sync with the MUI palette.
 */
export function applyBrandCssVars(brand, isDarkMode) {
  const mode = getBrandMode(brand, isDarkMode);
  const surface = isDarkMode ? DARK_SURFACE : LIGHT_SURFACE;
  const root = document.documentElement;
  const [r, g, b] = hexToRgb(mode.main);

  const [cmr, cmg, cmb] = hexToRgb(mode.chartMuted);

  root.style.setProperty("--brand", mode.main);
  root.style.setProperty("--brand-hover", mode.hover);
  root.style.setProperty("--brand-rgb", `${r}, ${g}, ${b}`);
  root.style.setProperty("--brand-chart-light", mode.chartLight);
  root.style.setProperty("--brand-chart-muted", mode.chartMuted);
  root.style.setProperty("--brand-chart-muted-rgb", `${cmr}, ${cmg}, ${cmb}`);
  root.style.setProperty("--brand-surface-tint", mode.surfaceTint);

  root.style.setProperty("--app-bg", surface.bgDefault);
  root.style.setProperty("--app-paper", surface.bgPaper);
  root.style.setProperty("--app-text", surface.textPrimary);
  root.style.setProperty("--app-text-muted", surface.textSecondary);

  root.style.setProperty("--dx-color-main-bg", surface.bgDefault);
  root.style.setProperty("--dx-component-color-bg", surface.bgPaper);
  root.style.setProperty("--dx-color-border", surface.divider);
  root.style.setProperty("--dx-color-separator", surface.divider);
  root.style.setProperty("--dx-color-link", mode.main);

  root.style.setProperty("--accent", mode.chartLight);

  for (const varName of BRAND_CSS_VARS) {
    if (varName === "--brand" || varName === "--accent") {
      continue;
    }
    root.style.setProperty(varName, mode.main);
  }
}
